import { useState } from 'react';
import { Drawer } from '@mui/material';
import { PageWithLayout } from '@/pages/_app';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { BillingsContent } from '@starjack/widgets/billings';
import { BillingDrawerContent } from '@/pageContents/billings/BillingDrawerContent';
import { Permission } from '@/models/user';
import type { Billing } from '@starjack/entities/billing';

const Billings: PageWithLayout = () => {
    const [drawerConfig, setDrawerConfig] = useState<{
        isOpen: boolean;
        billing: Billing;
    }>({ isOpen: false, billing: null });

    const onCloseDrawer = () => {
        setDrawerConfig((prevState) => ({
            ...prevState,
            isOpen: false,
        }));
    };

    return (
        <>
            <Helmet>
                <title>Abrechnungen | Starjack Backoffice</title>
            </Helmet>

            <BillingsContent
                variant='backoffice'
                onBillingSelect={(billing) =>
                    setDrawerConfig({ isOpen: true, billing })
                }
            />

            <Drawer
                anchor='right'
                open={drawerConfig.isOpen}
                onClose={onCloseDrawer}
            >
                <BillingDrawerContent
                    billing={drawerConfig.billing}
                    onClose={onCloseDrawer}
                />
            </Drawer>
        </>
    );
};

Billings.isProtected = true;
Billings.permissions = [Permission.ADMIN];
Billings.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;

export default Billings;
